import { produce } from 'immer';
import { orderBy } from 'lodash';

import { SortInternalMarketerProducts } from '../../../actions/marketer/internal/sortInternalMarketerProducts';
import { routeMarketerProductsToKeyMap } from '../../../service/MarketersHelper';
import { MarketerProduct, MarketerState } from '../../../typings/marketers';

export function sortInternalMarketerProducts(
    state: MarketerState,
    action: SortInternalMarketerProducts
): MarketerState {
    return produce(state, draft => {
        draft.marketer.ownProducts = orderBy<MarketerProduct>(
            state.marketer.ownProducts,
            [routeMarketerProductsToKeyMap[action.sortParams.key]],
            [action.sortParams.direction]
        );
    });
}
